export default __webpack_public_path__ + "static/media/interactive-agency.a6f2e6b9.png";